import { DateTime } from 'luxon';
import {
  ElegibilidadeMuralAvisos,
  ModalidadePeriodo,
  TipoCurso,
  ValorTodosSegmentacao,
} from './elegibilidade-mural-avisos.types';

const elegibilidadeMuralAvisos: ElegibilidadeMuralAvisos = {
  fases: [
    {
      fase: 1,
      habilitarAPartirDe: '12/05/2026',
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7022', '7024'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4070', '4389', '4334', '3631'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3592'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4340'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3629'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['19'],
        },
      ],
    },
    {
      fase: 2,
      habilitarAPartirDe: '19/05/2026',
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA, TipoCurso.ESPECIALIZACAO, TipoCurso.TECNICO],
          modalidade: [ValorTodosSegmentacao.TODOS],
          periodo: ['2026.1'],
          codigoCurso: [ValorTodosSegmentacao.TODOS],
        },
        {
          marcas: ['wyden', 'ibmec', 'idomed', 'unitoledo'],
          tipoCurso: [ValorTodosSegmentacao.TODOS],
          modalidade: [ValorTodosSegmentacao.TODOS],
          periodo: ['2026.1'],
          codigoCurso: [ValorTodosSegmentacao.TODOS],
        },
      ],
    },
    {
      fase: 3,
      habilitarAPartirDe: '26/05/2026',
      modo: 'TODOS',
    },
  ],
};

export const getElegibilidadeMuralAvisos = ({ ambiente }: { ambiente: string }): ElegibilidadeMuralAvisos => {
  if (ambiente === 'dev' || ambiente === 'local') {
    return {
      fases: [
        {
          fase: 1,
          habilitarAPartirDe: DateTime.now().minus({ day: 1 }).toFormat('dd/MM/yyyy'),
          modo: 'TODOS',
        },
      ],
    };
  }

  return elegibilidadeMuralAvisos;
};
